/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiWebInstytucjeNipCertyfikatyPost$Params {
  nip: string;
      body?: {
}
}

export function apiWebInstytucjeNipCertyfikatyPost(http: HttpClient, rootUrl: string, params: ApiWebInstytucjeNipCertyfikatyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiWebInstytucjeNipCertyfikatyPost.PATH, 'post');
  if (params) {
    rb.path('nip', params.nip, {});
    rb.body(params.body, 'application/xml');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiWebInstytucjeNipCertyfikatyPost.PATH = '/api/web/instytucje/{nip}/certyfikaty';
